import { render, staticRenderFns } from "./recommend-word2vec.vue?vue&type=template&id=fafaa23a&scoped=true&"
import script from "./recommend-word2vec.vue?vue&type=script&lang=js&"
export * from "./recommend-word2vec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafaa23a",
  null
  
)

export default component.exports